import { DRButton } from './DRControls';
import './PinCodeReminder.scss';

export interface PinCodeData {
  id: string;
  drawer: string;
  name: string;
  note: string;
  pinCode: string;
  codeGivenTo: string;
}

interface PinCodeReminderProps {
  pinCodeData: PinCodeData[];
  clickOkay: () => void;
}

export default function PinCodeReminder({ pinCodeData, clickOkay }: PinCodeReminderProps) {
  const renderButton = () => (
    <DRButton
      key="primary-button"
      phrase="OKAY"
      fillColor="transparent"
      borderColor="#0091ae"
      fontColor="#0091ae"
      action={clickOkay}
      fontSize={24}
      height={52}
      width={270}
    />
  );

  const renderCodes = () => {
    return pinCodeData.map((data) => (
      <div key={data.drawer} className="pin-code-reminder__details">
        <div className="pin-code-reminder__name">
          {data.name} - {data.drawer} Drawer
        </div>
        <div className="pin-code-reminder__number">{data.pinCode}</div>
      </div>
    ));
  };

  return (
    <div className="pin-code-reminder" role="dialog">
      <div className="pin-code-reminder__body">
        <div className="pin-code-reminder__title" role="heading" aria-level={1}>
          Multi-factor Delivery Codes
        </div>
        <div className="pin-code-reminder__wrapper">{renderCodes()}</div>
        <div className="pin-code-reminder__footer">{renderButton()}</div>
      </div>
      <div className="pin-code-reminder__overlay" role="presentation"></div>
    </div>
  );
}
